import { AutomatorBuilderPublishSetting } from '../_base';
import { customElement } from 'lit/decorators.js';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-publish-setting-user-type' )
export class AutomatorBuilderPublishSettingUserType extends AutomatorBuilderPublishSetting {
	// Unique identifier for this setting.
	settingID = 'recipe_user_type';

	// Icon representing this setting in the UI.
	icon = 'user';

	// Label displayed for this setting in the UI.
	label = _uo.utility.escHTML( wp.i18n.__( 'User type', 'uncanny-automator' ) );

	// Define the helper text for the setting.
	helper = _uo.utility.escHTML( wp.i18n.__( 'Specifies which user group can trigger this recipe, such as logged-in users or all users.', 'uncanny-automator' ) );

	/**
	 * Retrieves a readable version of the "User type" field value for display.
	 *
	 * @return {String|undefined} The type of user
	 */
	get readableValue() {
		// Get the value of the field "User type"
		const userType = this.getFieldValue( 'USER_TYPE' );

		if ( userType == 'user' ) {
			return _uo.utility.escHTML( wp.i18n.__( 'Logged-in users', 'uncanny-automator' ) );
		}

		if ( userType == 'anonymous' ) {
			return _uo.utility.escHTML( wp.i18n.__( 'Everyone', 'uncanny-automator' ) );
		}
	}

	/**
	 * Opens the helper for the setting.
	 */
	helperCallback() {
		_uo.utility.openWindow( {
			url: 'https://automatorplugin.com/knowledge-base/creating-a-recipe/?utm_source=uncanny_automator_pro&utm_medium=publish_metabox&utm_content=recipe_type_question_icon',
			w: 450
		} )
	}
}
